module.exports = __webpack_public_path__ + "img/add-item-button.5f964977.svg";